// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Poppins", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
    "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* styles.css */

/* Track */
::-webkit-scrollbar-track {
  background: rgba(119, 119, 119, 0.02);
}

::-webkit-scrollbar-track:hover {
  background: rgba(133, 133, 133, 0.034);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(20, 20, 20, 0.363);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(14, 14, 14, 0.76);
}

* {
  overflow: hidden;
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
}

input {
  border: none;
  outline: none;
  height: 1.7em;
  border-radius: 50px;
  font-size: 0.9em;
  padding-left: 35px;
}
/* styles.css */
.stage-enter {
  opacity: 0;
  transform: translateX(-100%);
}
.stage-enter-active {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 300ms, transform 300ms;
}
.stage-exit {
  opacity: 1;
  transform: translateX(0);
}
.stage-exit-active {
  opacity: 0;
  transform: translateX(100%);
  transition: opacity 300ms, transform 300ms;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAIA;EACE,SAAS;EACT;8CAC4C;EAC5C,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,eAAe;;AAEf,UAAU;AACV;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,WAAW;AACX;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,eAAe;AACf;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B,0CAA0C;AAC5C","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\nbody {\n  margin: 0;\n  font-family: \"Poppins\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\",\n    \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n\n/* styles.css */\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: rgba(119, 119, 119, 0.02);\n}\n\n::-webkit-scrollbar-track:hover {\n  background: rgba(133, 133, 133, 0.034);\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: rgba(20, 20, 20, 0.363);\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(14, 14, 14, 0.76);\n}\n\n* {\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  margin: 0;\n}\n\ninput {\n  border: none;\n  outline: none;\n  height: 1.7em;\n  border-radius: 50px;\n  font-size: 0.9em;\n  padding-left: 35px;\n}\n/* styles.css */\n.stage-enter {\n  opacity: 0;\n  transform: translateX(-100%);\n}\n.stage-enter-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 300ms, transform 300ms;\n}\n.stage-exit {\n  opacity: 1;\n  transform: translateX(0);\n}\n.stage-exit-active {\n  opacity: 0;\n  transform: translateX(100%);\n  transition: opacity 300ms, transform 300ms;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
